import { render, staticRenderFns } from "./ConfirmOffer.vue?vue&type=template&id=20d7b847&scoped=true&"
import script from "./ConfirmOffer.vue?vue&type=script&lang=js&"
export * from "./ConfirmOffer.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmOffer.vue?vue&type=style&index=0&id=20d7b847&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d7b847",
  null
  
)

export default component.exports